import { EventEmitter } from 'events';


class ServerAdapter extends EventEmitter {

  constructor(userId, userColor) {
    super();
    this.userId_ = userId;
    this.userColor_ = userColor;
  }

  dispose() { }

  setUserId(userId) { this.userId_ = userId; }

  setUserColor(userColor) { this.userColor_ = userColor; }

  /*
   * Send operation, retrying on connection failure. Takes an optional callback with signature:
   * function(error, committed).
   * An exception will be thrown on transaction failure, which should only happen on
   * catastrophic failure like a security rule violation.
   */
  sendOperation(operation, callback) {
    console.warn("not implemented: sendOperation(operation, callback)");
  }
    
  sendCursor(obj) {
    console.warn("not implemented: sendCursor(obj)");
  }

  /** @deprecated adapter for `utils.makeEventEmitter`-style usage */
  trigger(eventType, ...eventData) {
    this.emit(eventType, ...eventData);
  }

  /**
   * Events should be one of:
   * ['ready', 'cursor', 'operation', 'ack', 'retry']
   */
  registerCallbacks(callbacks) {
    for (var eventType in callbacks) {
      this.on(eventType, callbacks[eventType]);
    }
  }
}

export { ServerAdapter }
